import React from 'react';

import {Button} from 'reactstrap';
import CardHeader from "@material-ui/core/CardHeader"
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import {Tab,Tabs} from "@material-ui/core";
import CardContent from '@material-ui/core/CardContent';

import {loadStripe} from '@stripe/stripe-js';
import {Elements} from '@stripe/react-stripe-js';
import { Collections } from 'components';

import Account from "components/Objects/Account";
import BillingObject from "components/Objects/Billing";
import SubscriptionObject from "components/Objects/Subscription";
import CustomReceipt from "components/Objects/AccountCustomizations";
import AccountRegisterAuditing from "components/Objects/AccountRegisterAuditing";
import AccountIntegrations from "components/Objects/AccountIntegrations";
import AccountQuickCheckout from "components/Objects/AccountQuickCheckout";
import APPCONFIG from "constants/Config";
import Framework from "@beardeddevops/react.framework"
import API from "@beardeddevops/react.api";
import Types from "../../../../../constants/Types";
import {confirmAlert} from "react-confirm-alert";
import {isAccountOwnerLogin} from "../../../../../utils/accountAccess";
import {showBillingError, showBillingSuccess} from "utils/billingErrors";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Account',
		url: '/settings',
		icon: 'address-card-o',
	},
];

class Settings extends Framework.Components.View {

	constructor(props) {
		super(props,'details');
		this.state.warning_shown = false;
		this.state.submitting = false;
	}

	componentDidMount() {
		this.state.showSubscribe = this.props.rootState.no_subscription && !this.props.rootState.fflboss_pos_combo;
		this.state.card_error = true;
		if (this.props.rootState.failedBilling && !this.props.rootState.fflboss_pos_combo && !this.state.warning_shown) {
			API.Toast.error('Your Stripe subscription is no longer active. Please ensure your card details are up to date. If the issue persists, contact support.', {
				position: API.Toast.POSITION.TOP_RIGHT,
				autoClose: 180000, // 3 minutes in milliseconds
				closeOnClick: true,
				pauseOnHover: true,
			});
			this.setState({warning_shown: true})
		}
	}

	runBillingRequest = async ({requestType, method, successMessage, failureFallback, onClose}) => {
		if (this.state.submitting === true) {
			return;
		}

		this.setState({submitting: true});
		try {
			const billing = new API.BuildClass(Types.Accounts_Billing._name, requestType);
			await billing.submit(null, method, true);
			if (successMessage) {
				showBillingSuccess(API, successMessage);
			}
			if (typeof onClose === 'function') {
				onClose();
			}
			window.location.reload();
		} catch (error) {
			showBillingError(API, error, failureFallback);
			this.setState({submitting: false});
			if (typeof onClose === 'function') {
				onClose();
			}
		}
	}

	handleSubscribe = async (ev) => {
		ev.preventDefault();
		const isTacticalBillingAccount = !!(this.props.rootState.is_tactical || this.props.rootState.isTactical);

		if(isTacticalBillingAccount){
			await this.runBillingRequest({
				requestType: API.RequestType.READ,
				method: 'GET_CREATE_STRIPE_TERMINAL',
				successMessage: 'Subscription created successfully.',
				failureFallback: 'Unable to create the Stripe subscription.',
			});
		} else {
			confirmAlert({
				customUI: ({onClose}) => {
					return (
						<Card>
							<CardContent style={{display: 'grid'}}>
								<b style={{fontSize: '16px'}}>Please select the plan you wish to subscribe to. <br/><br/><i>You cannot use terminals with Cash Only</i></b>
							</CardContent>
							<CardActions>
								<Button className="primary-button"
								        onClick={async () => {
									        await this.runBillingRequest({
										        requestType: API.RequestType.READ,
										        method: 'GET_CREATE_STRIPE_CASH',
										        successMessage: 'Cash Only subscription created successfully.',
										        failureFallback: 'Unable to create the Cash Only subscription.',
										        onClose,
									        });
								        }}>Cash Only</Button>
								<Button className="primary-button"
								        onClick={async () => {
									        await this.runBillingRequest({
										        requestType: API.RequestType.READ,
										        method: 'GET_CREATE_STRIPE_TERMINAL',
										        successMessage: 'Terminals subscription created successfully.',
										        failureFallback: 'Unable to create the Terminals subscription.',
										        onClose,
									        });
								        }}>Terminals</Button>
								<Button className="secondary-button"
								        onClick={() => {
									        onClose();
								        }}>Cancel</Button>
							</CardActions>
						</Card>
					)
				}
			});
		}
	}

	handleResubscribe = async (ev) => {
		ev.preventDefault();

		confirmAlert({
			customUI: ({onClose}) => {
				return (
					<Card>
						<CardContent style={{display: 'grid'}}>
							<b style={{fontSize: '16px'}}>Are you sure you want to resubscribe?</b>
						</CardContent>
						<CardActions>
							<Button className="primary-button"
							        onClick={async () => {
								        await this.runBillingRequest({
									        requestType: API.RequestType.READ,
									        method: (this.props.rootState.location_plan === 1 || this.props.rootState.location_plan === 3)
										        ? 'GET_CREATE_STRIPE_TERMINAL'
										        : 'GET_CREATE_STRIPE_CASH',
									        successMessage: 'Subscription recovered successfully.',
									        failureFallback: 'Unable to recover the Stripe subscription. Please update your card and try again.',
									        onClose,
								        });
							        }}>Yes</Button>
							<Button className="primary-button"
							        onClick={() => {onClose();}}>No</Button>
						</CardActions>
					</Card>
				)
			}
		});
	}

	handleClear = async (ev) => {
		ev.preventDefault();

		confirmAlert({
			title: 'Cancel Subscription',
			message: 'Are you sure you want to cancel the subscription for this account?',
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						await this.runBillingRequest({
							requestType: API.RequestType.DELETE,
							method: 'DELETE_CANCEL',
							successMessage: 'Subscription canceled.',
							failureFallback: 'Unable to cancel the Stripe subscription.',
						});
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}

	getCardLastFour = (lastFour) => {
		this.lastFour = lastFour;
	}

		render() {

			// Create the Stripe object yourself...
			const isTacticalPay = window.isTacticalPay;
			const isTacticalBillingAccount = !!(this.props.rootState.is_tactical || this.props.rootState.isTactical);
			const isFflBossManaged = !!this.props.rootState.fflboss_pos_combo;
			const stripePromise = loadStripe(
				APPCONFIG.settings.isDev() ? "pk_test_tRSfBrW6ZVEDUfzR5Z9LS0Dc" : "pk_live_5xbn5wfaZ994xK2auzKck9dp",
				isTacticalBillingAccount ? {stripeAccount: APPCONFIG.settings.tacticalConnectedAccountId()} : undefined
			);

		const appearance = {
			theme: 'stripe'
		};

		//Pass to BillingObject
		let subscriptionFailed = this.props.rootState.failedSubscription;

		let { no_subscription, failedBilling } = this.props.rootState;
		const isCashPlan = this.props.rootState.location_plan === 2;
		const showAltrupayTerminals = this.props.rootState.altrupay_linked && !isCashPlan;
		const showSubscriptionActions = !isFflBossManaged && (no_subscription || failedBilling || (!no_subscription && !subscriptionFailed));
		const showSubscriptionDivider = !isFflBossManaged && (no_subscription || (!no_subscription && !subscriptionFailed) || failedBilling);
		const showQuickCheckoutSettings = isAccountOwnerLogin(this.props.rootState);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}/>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component="div">
					{showAltrupayTerminals &&
					<Tab label={isTacticalPay ? "TacticalPay Terminals" : "AltruPay Terminals"} value={isTacticalPay ? 'tacticalpay' : "altrupay"}/>
					}
					<Tab label="Account Settings" value="details"/>
					<Tab label="Billing" value="billing"/>
					<Tab label="Customizations" value="customizations"/>
					<Tab label="Register Auditing" value="register-auditing"/>
					<Tab label="Integrations" value="integrations"/>
					{showQuickCheckoutSettings && (
						<Tab label="Quick Checkout" value="quick-checkout"/>
					)}
				</Tabs>

				<div style={{display: this.state.tab === "details" ? "block" : "none"}}>
					<Account
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
					/>
				</div>

				<div id="billingContainer" style={{display: this.state.tab === "billing" ? "" : "none"}}>
					<div id="billingObject">
						<Card>
							<CardContent>
								<Elements stripe={stripePromise}>
									<BillingObject
										subFailed={subscriptionFailed}
										baseUrl={'/accounts#billing'}
										reloadPage={this.refreshPage}
										reloadSelf={this.state.refresh}
										history={this.props.history}
										cardExists={this.lastFour}
									/>
								</Elements>
							</CardContent>
						</Card>

				</div>
					<Framework.Errors.General isDev={APPCONFIG.settings.isDev()}>

							<div id="subscriptionObject">
								<Card>
									<CardContent style={{paddingBottom: 0}}>
										<SubscriptionObject
											reloadPage={this.refreshPage}
											reloadSelf={this.state.refresh}
											baseUrl={'/settings#billing'}
											history={this.props.history}
											setCardError={(card_error) => {this.setState({card_error})}}
											cardExists={this.getCardLastFour}
										/>
										{showSubscriptionDivider ? <hr style={{marginBottom: 0}}/> : null}
									</CardContent>
									<CardActions style={{justifyContent: 'flex-end', padding: '16px'}}>
										{no_subscription && (
											<Button className="primary-button" onClick={this.handleSubscribe}>
												Subscribe
											</Button>
										)}
										{failedBilling && (
											<Button className="secondary-button" onClick={this.handleResubscribe}>
												Resubscribe
											</Button>
										)}
										{!no_subscription && !subscriptionFailed && (
											<Button color='danger' className='danger-button' onClick={this.handleClear}>
												Cancel Subscription
											</Button>
										)}
									</CardActions>
								</Card>
							</div>
					</Framework.Errors.General>
				</div>

				<div style={{display: this.state.tab === "customizations" ? "block" : "none"}}>
					<CustomReceipt history={this.props.history}
					               reloadPage={this.refreshPage}
					               reloadSelf={this.state.refresh}
					               id={this.props.rootState.receiptCustomizationId}
					               account={this.props.rootState.account}
					/>
				</div>

				<div style={{display: this.state.tab === "register-auditing" ? "block" : "none"}}>
					<AccountRegisterAuditing
						history={this.props.history}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						id={this.props.rootState.receiptCustomizationId}
						account={this.props.rootState.account}
					/>
				</div>

				<div style={{display: this.state.tab === "integrations" ? "block" : "none"}}>
					<AccountIntegrations history={this.props.history}
					               reloadPage={this.refreshPage}
					               reloadSelf={this.state.refresh}
					               id={this.props.rootState.receiptCustomizationId}
					               account={this.props.rootState.account}
					/>
				</div>

				{showQuickCheckoutSettings && (
					<div style={{display: this.state.tab === "quick-checkout" ? "block" : "none"}}>
						<AccountQuickCheckout
							history={this.props.history}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
							id={this.props.rootState.receiptCustomizationId}
							account={this.props.rootState.account}
						/>
					</div>
				)}

				<div style={{display: showAltrupayTerminals && (this.state.tab === "altrupay" || this.state.tab === "tacticalpay") ? "block" : "none"}}>
					<Collections.AltruPayTerminals history={this.props.history}
					               reloadPage={this.refreshPage}
					               reloadSelf={this.state.refresh}
					               account={this.props.rootState.account}
					/>
				</div>
			</div>
		);
	}
}

export default Framework.Components.withRootState(Settings);
